export default __webpack_public_path__ + "static/media/icons8-document.04e7280c.svg";